var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Invoices" },
    [
      _c(
        "div",
        {
          class: [
            "row row--align-center row--justify-between",
            {
              "mb-30": _vm.user.client && !_vm.mobile.isMobile,
              "mb-0 ml-16": _vm.mobile.isMobile
            }
          ]
        },
        [
          _vm.mobile.isMobile
            ? _c("label", { staticClass: "fc-light fs-14 mt-15 mb-15" }, [
                _vm._v("\n      " + _vm._s(_vm.mobileHelperText) + "\n    ")
              ])
            : _vm._e()
        ]
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }